module.exports = __webpack_public_path__ + "7fad20dd1210f15c9f0823addf445a69.MP3";